import {Button, Typography} from '@customink/pigment-react';
import React, {ReactElement} from 'react';
import {useHistory} from 'react-router-dom';
import services from '../../api/remoteServices';
import {useAppSelector} from '../../hooks';
import ShirtImage from '../../assets/TemplateShirt.svg';
import './index.scss';

type StoreProductsEmptyProps = {
  storeSlug: string;
};
const StoreProductEdit: React.FC<StoreProductsEmptyProps> = ({
  storeSlug
}: StoreProductsEmptyProps): ReactElement => {
  const history = useHistory();
  const storeDetails = useAppSelector(state => state.stores.storeDetails);

  const handleAddProductClick = () => {
    if (storeDetails?.eventStore && storeDetails?.deleteProductsEnabled) {
      let redirectUrl = `${
        services.stores
      }/${storeSlug}/admin/products/new?redirect_url=${encodeURIComponent(
        `${services.storefront}/${storeSlug}/manage/products`
      )}&compatible_type_only=true&quote=true`;

      if (storeDetails.designCompositeId) {
        redirectUrl += `&cid=${storeDetails.designCompositeId}`;
      }

      window.location.href = redirectUrl;
    } else {
      history.push(`/${storeSlug}/products/new`);
    }
  };

  return (
    <div className="storeProductsEmpty">
      <h2>Your Products</h2>
      <div className="storeProductsEmpty-emptyContainter">
        <div className="storeProductsEmpty-emptyText">
          <img
            className="storeProductsEmpty-shirtImage"
            src={ShirtImage}
            alt="Template shirt"
          />
          <Typography
            className="storeProductsEmpty-addProduct"
            variant="subHeading"
            paragraph>
            Let&apos;s add a few products!
            <div className="storeProductsEmpty-clickText">
              Click the button to launch our Product Builder.
            </div>
          </Typography>
          <Button
            className="storeProductsEmpty-addButton"
            disabled={
              storeDetails &&
              storeDetails.fulfillVia === 'wave' &&
              !(storeDetails.deleteProductsEnabled === true)
            }
            variant="tertiary"
            onClick={handleAddProductClick}>
            Add Product
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StoreProductEdit;
